module.exports = __webpack_public_path__ + "static/media/PrevDisabled-wo-background.b576e97e.svg";